// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_3isQkm2ULED659Vl3ZiLuc","spaceLeft":"_3kYWSenkf1wU-TYttXstk7","spaceBoth":"_2vWvZFpB1p88vA3wyxJYdK","spaceRight":"_1GUmSfWn1njjukYvCTvcdd","available":"_1FULkT4Q0GSEhO0MinJz5z","available-amount":"_1K-GnlLyBrlZbE-cP7ftof","available-currency":"_2JCABBtuQSXWlrBZE5X1Jr","loading":"_2dd_K_iD20qqwo8riCMpIS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisTokenBalance.scss
// module id = 1226
// module chunks = 0